import { defineMessages } from 'react-intl';

export default defineMessages({
  download52670: {
    id: 'manageHudVoucherDetails.download52670',
    defaultMessage: 'Download 52670',
  },
  goBackToManageHudVouchers: {
    id: 'voucherDetailsLayout.goBackToManageHudVouchers',
    defaultMessage: 'Go back to Manage HUD Vouchers',
  },
  voucherDetailsTitle: {
    id: 'voucherDetailsLayout.voucherDetailsTitle',
    defaultMessage: 'Voucher Details: {tracsVoucherId}',
  },
  requested: {
    id: 'voucherDetailsLayout.requested',
    defaultMessage: 'Requested',
  },
  paid: {
    id: 'voucherDetailsLayout.paid',
    defaultMessage: 'Paid',
  },
  subsidyType: {
    id: 'voucherDetailsLayout.subsidyType',
    defaultMessage: 'Subsidy Type:',
  },
  contractNumber: {
    id: 'voucherDetailsLayout.contractNumber',
    defaultMessage: 'Contract Number:',
  },
  voucherYearMonth: {
    id: 'voucherDetailsLayout.voucherMonthYear',
    defaultMessage: 'Voucher Year/Month:',
  },
  voucherStatus: {
    id: 'voucherDetailsLayout.voucherStatus',
    defaultMessage: 'Voucher Status:',
  },
  downloadVoucher: {
    id: 'voucherDetailsLayout.downloadVoucher',
    defaultMessage: 'Download Voucher',
  },
  notAvailable: {
    id: 'voucherDetailsLayout.notAvailable',
    defaultMessage: '---',
  },
  submissionStatusDraft: {
    id: 'voucherDetailsLayout.submissionStatusDraft',
    defaultMessage: 'Draft',
  },
  submissionStatusSubmitted: {
    id: 'voucherDetailsLayout.submissionStatusSubmitted',
    defaultMessage: 'Submitted',
  },
  submissionStatusNotSubmitted: {
    id: 'voucherDetailsLayout.submissionStatusNotSubmitted',
    defaultMessage: 'Not Submitted',
  },
  submissionStatusApproved: {
    id: 'voucherDetailsLayout.submissionStatusApproved',
    defaultMessage: 'Approved',
  },
  submissionStatusError: {
    id: 'voucherDetailsLayout.submissionStatusError',
    defaultMessage: 'Error',
  },
  submissionStatusPaid: {
    id: 'voucherDetailsLayout.submissionStatusPaid',
    defaultMessage: 'Paid',
  },
  submissionStatusSuccessful: {
    id: 'voucherDetailsLayout.submissionStatusSuccessful',
    defaultMessage: 'Successful',
  },
  submittedChangesWarningTitle: {
    id: 'voucherDetailsLayout.submittedChangesWarningTitle',
    defaultMessage:
      'A change has been made on the Voucher, which has moved it back to DRAFT status.',
  },
  submittedChangesWarningBody: {
    id: 'voucherDetailsLayout.submittedChangesWarningBody',
    defaultMessage:
      'This Voucher must be resubmitted with the changes made. ' +
      'If you do not want to resubmit the Voucher with these changes, ' +
      'please select “Undo”. Undo will restore the Voucher back to ' +
      'the latest SUBMITTED version.',
  },
  undoSubmittedChanges: {
    id: 'voucherDetailsLayout.undoSubmittedChanges',
    defaultMessage: 'Undo',
  },
  varianceWarningMessage: {
    id: 'voucherDetailsLayout.varianceWarningMessage',
    defaultMessage:
      'There is a variance on this voucher. You must go to the bucket(s) with the variance & update ' +
      'the Approved Amount on the applicable entry or entries to match the HUD/CA Approved Amount. ' +
      'Once there are no more variance(s) showing in the buckets, select the Approve Payment button ' +
      'again to finalize this Voucher.',
  },
});
